import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import DesktopNavItem from './desktop_nav_item';
import MobileNavItem from './mobile_nav_item';
import GhostButton from '../../ui_kit/utilities/ghost_button';
import { useTransition, useChain, animated, useSpringRef } from '@react-spring/web';
import Context from '../../../utils/context';
import styles from './index.module.css';
import './header.css';
import { showLoginButton } from '../../../helpers/header_helper';

export default function Header({ xcopri = false }) {
  const context = useContext(Context);
  const [navOpen, setNavOpen] = useState(false);

  // Listens to know if the device is a mobile device START
  const [isMobile, setDesktop] = useState(window.innerWidth < 1191);
  const showLogin = showLoginButton(context.auth.isLoggedIn(), isMobile);

  const updateMedia = () => {
    setDesktop(window.innerWidth < 1191);
  };

  useEffect(() => {
    window.addEventListener('resize', updateMedia);
    return () => window.removeEventListener('resize', updateMedia);
  });
  // Listens to know if the device is a mobile device END

  // Listens to know if the device is a mobile device START
  const [isSmallMobile, setSmallMobile] = useState(window.innerWidth < 534);

  const updateSmallMedia = () => {
    setSmallMobile(window.innerWidth < 534);
  };

  useEffect(() => {
    window.addEventListener('resize', updateSmallMedia);
    return () => window.removeEventListener('resize', updateSmallMedia);
  });
  // Listens to know if the device is a mobile device END

  const menuItems = [
    {
      mainLink: {
        title: 'Find support',
        link: '',
      },
      dropdown: [
        {
          title: 'Meet our mentors',
          smallTitle: 'Connect with a recovered patient',
          link: '/partners',
          props: {
            to: '/partners',
          },
          icon: (
            <svg width='24' height='15' viewBox='0 0 24 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path
                d='M19.47 2.39625L17.685 0.61125C17.2899 0.219683 16.7562 -4.34474e-06 16.2 0H7.695C7.14 0 6.60375 0.22125 6.21 0.61125L4.425 2.39625H0V11.985H2.4C3.06 11.985 3.5925 11.4525 3.59625 10.7963H3.9375L7.11 13.6613C8.26875 14.6025 9.8775 14.625 11.07 13.8038C11.5388 14.2088 12.045 14.4 12.6113 14.4C13.2938 14.4 13.935 14.1225 14.4413 13.5C15.27 13.8263 16.2488 13.5975 16.8413 12.87L17.8238 11.6588C18.0338 11.4 18.165 11.1038 18.2325 10.7963H20.4037C20.4075 11.4525 20.9438 11.985 21.6 11.985H24V2.39625H19.47ZM1.8 10.785C1.47 10.785 1.2 10.515 1.2 10.185C1.2 9.855 1.47 9.585 1.8 9.585C2.13 9.585 2.4 9.855 2.4 10.185C2.4 10.5188 2.13 10.785 1.8 10.785ZM16.425 10.5263L15.4463 11.7338C15.3413 11.8613 15.1538 11.8838 15.0225 11.7788L14.1263 11.0513L13.0013 12.42C12.7763 12.6938 12.4388 12.6 12.3263 12.51L10.9463 11.3288L10.3612 12.0488C9.84 12.69 8.89125 12.7875 8.2875 12.2963L4.63875 8.99625H3.6V4.1925H5.17125L7.485 1.8825C7.56 1.8525 7.62375 1.82625 7.69875 1.79625H9.825L8.37375 3.1275C7.27125 4.13625 7.2075 5.83875 8.20875 6.92625C8.76375 7.53375 10.5038 8.47125 12.015 7.09125L12.3225 6.81L16.38 10.1025C16.5075 10.2075 16.5263 10.3988 16.425 10.5263V10.5263ZM20.4 8.99625H17.805C17.7188 8.89125 17.6213 8.79375 17.5163 8.7075L13.665 5.58L14.1338 5.1525C14.3775 4.9275 14.3963 4.54875 14.1713 4.305L13.7625 3.86625C13.5375 3.6225 13.1588 3.6075 12.915 3.82875L10.845 5.72625C10.4888 6.0525 9.88125 6.07875 9.5475 5.72625C9.19875 5.355 9.22875 4.785 9.5925 4.455L12.0525 2.20125C12.33 1.94625 12.69 1.8075 13.065 1.8075L16.2038 1.8C16.2825 1.8 16.3575 1.83 16.41 1.88625L18.7238 4.19625H20.4V8.99625V8.99625ZM22.2 10.785C21.87 10.785 21.6 10.515 21.6 10.185C21.6 9.855 21.87 9.585 22.2 9.585C22.53 9.585 22.8 9.855 22.8 10.185C22.8 10.5188 22.53 10.785 22.2 10.785Z'
                fill='#173959'
              />
            </svg>
          ),
        },
      ],
    },
    {
      mainLink: {
        title: 'How it works',
        link: '',
      },
      dropdown: [
        {
          title: 'How it works',
          smallTitle: 'A guide to get you started',
          link: '/how-it-works',
          props: {
            to: '/how-it-works',
          },
          icon: (
            <svg width='26' height='19' viewBox='0 0 26 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path
                d='M16.3612 10.6469L14.4356 9.90291C14.4793 9.64033 14.4793 9.42151 14.4793 9.15892C14.4793 8.4587 14.348 7.80224 14.1292 7.14578L15.836 5.96415L14.2167 3.60089L12.5099 4.78252C11.8535 4.16982 11.022 3.73218 10.1029 3.51336V1.45645H7.25826V3.51336C6.33921 3.73218 5.5077 4.16982 4.85124 4.78252L3.14444 3.64465L1.52517 6.00791L3.1882 7.14578C2.96938 7.75847 2.83809 8.4587 2.83809 9.15892C2.83809 9.42151 2.83809 9.68409 2.88185 9.94668L1 10.6907L2.05034 13.3603L3.97596 12.5725C4.76371 13.6666 5.94534 14.4544 7.25826 14.8045V16.8176H10.1029V14.8045C11.4596 14.4544 12.5975 13.6666 13.429 12.5725L15.3546 13.3165L16.3612 10.6469Z'
                stroke='#173959'
                strokeWidth='2'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M10.3719 9.11519C10.3719 10.0373 9.62442 10.7848 8.70232 10.7848C7.78022 10.7848 7.03271 10.0373 7.03271 9.11519C7.03271 8.1931 7.78022 7.44559 8.70232 7.44559C9.62442 7.44559 10.3719 8.1931 10.3719 9.11519Z'
                stroke='#173959'
                strokeWidth='2'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M25.8141 3.33832H25.0701C24.9826 3.33832 24.8951 3.29456 24.8513 3.16327C24.72 2.76939 24.545 2.41928 24.2824 2.11293C24.2386 2.0254 24.2386 1.93787 24.2824 1.85034L24.72 1.23765C24.7638 1.15012 24.7638 1.01883 24.6763 0.931299L23.7572 0.274838C23.6697 0.231074 23.5384 0.231074 23.4509 0.318602L23.057 0.931299C23.0132 1.01883 22.9257 1.01883 22.7944 1.01883C22.4881 0.931299 22.1817 0.887535 21.8316 0.887535C21.7441 0.887535 21.6565 0.887535 21.569 0.887535C21.4815 0.887535 21.394 0.843771 21.3502 0.756243L21.0876 0.056018C21.0438 0.056018 20.9126 -0.0315101 20.825 0.0122539L19.7309 0.449894C19.6434 0.493658 19.5559 0.624951 19.5996 0.712479L19.8622 1.4127C19.906 1.50023 19.8622 1.58776 19.7747 1.67529C19.2933 2.06916 18.8994 2.59433 18.7244 3.20703C18.6806 3.29456 18.6368 3.38209 18.5055 3.38209H17.7615C17.6303 3.38209 17.5427 3.46961 17.5427 3.60091V4.73877C17.5427 4.87006 17.6303 4.95759 17.7615 4.95759H18.5055C18.5931 4.95759 18.6806 5.00136 18.7244 5.13265C18.8994 5.74534 19.2933 6.31428 19.7747 6.70815C19.8622 6.75192 19.8622 6.88321 19.8622 6.97074L19.5996 7.67096C19.5559 7.75849 19.5996 7.88978 19.7309 7.93355L20.7813 8.37119C20.8688 8.41495 21.0001 8.37119 21.0438 8.23989L21.3064 7.53967C21.3502 7.45214 21.4377 7.40838 21.5253 7.40838C21.6128 7.40838 21.7003 7.40838 21.7878 7.40838C22.0942 7.40838 22.4443 7.36461 22.7506 7.27709C22.8382 7.23332 22.9257 7.27709 22.9695 7.36461L23.4071 7.97731C23.4509 8.06484 23.5822 8.1086 23.7135 8.02107L24.6325 7.36461C24.72 7.32085 24.7638 7.18956 24.6763 7.05827L24.2386 6.44557C24.1949 6.35804 24.1949 6.27051 24.2386 6.18298C24.5012 5.87664 24.6763 5.52652 24.8076 5.13265C24.8513 5.04512 24.8951 4.95759 25.0264 4.95759H25.7704C25.9017 4.95759 25.9892 4.87006 25.9892 4.73877V3.55714C26.0329 3.42585 25.9454 3.33832 25.8141 3.33832ZM21.8316 5.61405C21.0438 5.61405 20.3874 4.95759 20.3874 4.16984C20.3874 3.38209 21.0438 2.72562 21.8316 2.72562C22.6194 2.72562 23.2758 3.38209 23.2758 4.16984C23.2758 4.95759 22.6631 5.61405 21.8316 5.61405Z'
                fill='#173959'
              />
              <path
                d='M25.8141 13.4916H25.0701C24.9826 13.4916 24.8951 13.4478 24.8513 13.3165C24.72 12.9226 24.545 12.5725 24.2824 12.2662C24.2386 12.1787 24.2386 12.0911 24.2824 12.0036L24.72 11.3909C24.7638 11.3034 24.7638 11.1721 24.6763 11.0846L23.7135 10.5156C23.6259 10.4719 23.4946 10.4719 23.4071 10.5594L23.0132 11.1721C22.9695 11.2596 22.8819 11.2596 22.7506 11.2596C22.4443 11.1721 22.1379 11.1283 21.7878 11.1283C21.7003 11.1283 21.6128 11.1283 21.5253 11.1283C21.4377 11.1283 21.3502 11.0846 21.3064 10.997L21.0438 10.2968C21.0001 10.2093 20.8688 10.1217 20.7813 10.1655L19.7309 10.6032C19.6434 10.6469 19.5559 10.7782 19.5996 10.8657L19.8622 11.566C19.906 11.6535 19.8622 11.741 19.7747 11.8285C19.2933 12.2224 18.8994 12.7476 18.7244 13.3603C18.6806 13.4478 18.6368 13.5353 18.5055 13.5353H17.7615C17.6303 13.5353 17.5427 13.6229 17.5427 13.7542V14.892C17.5427 15.0233 17.6303 15.1108 17.7615 15.1108H18.5055C18.5931 15.1108 18.6806 15.1546 18.7244 15.2859C18.8994 15.8986 19.2933 16.4675 19.7747 16.8614C19.8622 16.9052 19.8622 17.0365 19.8622 17.124L19.5996 17.8242C19.5559 17.9117 19.5996 18.043 19.7309 18.0868L20.7813 18.5244C20.8688 18.5682 21.0001 18.5244 21.0438 18.3932L21.3064 17.6929C21.3502 17.6054 21.4377 17.5616 21.5253 17.5616C21.6128 17.5616 21.7003 17.5616 21.7878 17.5616C22.0942 17.5616 22.4443 17.5179 22.7506 17.4303C22.8382 17.3866 22.9257 17.4303 22.9695 17.5179L23.4071 18.1306C23.4509 18.2181 23.5822 18.2619 23.7135 18.1743L24.6325 17.5179C24.72 17.4741 24.7638 17.3428 24.6763 17.2115L24.2386 16.5988C24.1949 16.5113 24.1949 16.4238 24.2386 16.3362C24.5012 16.0299 24.6763 15.6798 24.8076 15.2859C24.8513 15.1984 24.8951 15.1108 25.0264 15.1108H25.7704C25.9017 15.1108 25.9892 15.0233 25.9892 14.892V13.7542C26.0329 13.5791 25.9454 13.4916 25.8141 13.4916ZM21.8316 15.7673C21.0438 15.7673 20.3874 15.1108 20.3874 14.3231C20.3874 13.5353 21.0438 12.8789 21.8316 12.8789C22.6194 12.8789 23.2758 13.5353 23.2758 14.3231C23.2758 15.1108 22.6631 15.7673 21.8316 15.7673Z'
                fill='#173959'
              />
            </svg>
          ),
        },
      ],
    },
    {
      mainLink: {
        title: 'Industry partners',
        link: 'https://www.patientpartner.com/',
      },
    },
    {
      mainLink: {
        title: 'Who we are',
        link: '',
      },
      dropdown: [
        {
          title: 'About us',
          smallTitle: 'Learn about our story',
          link: '/who-we-are',
          props: {
            to: '/who-we-are',
          },
          icon: (
            <svg width='22' height='16' viewBox='0 0 22 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M13.4752 6.8C13.9646 6.38903 14.3501 5.85839 14.5868 5.25294C14.6927 4.98225 14.7687 4.69659 14.8111 4.4C14.8367 4.22039 14.85 4.03675 14.85 3.85C14.85 3.54777 14.8153 3.25372 14.7495 2.97163C14.3526 1.2677 12.8256 0 11 0C9.17442 0 7.64742 1.2677 7.25046 2.97162C7.18475 3.25372 7.15 3.54777 7.15 3.85C7.15 4.03675 7.16327 4.22039 7.18891 4.4C7.23125 4.6966 7.30734 4.98225 7.41318 5.25294C7.64988 5.85839 8.03537 6.38903 8.52478 6.8C8.56429 6.83318 8.60447 6.86557 8.64531 6.89717C8.86253 7.0652 9.09823 7.21051 9.34888 7.32954C9.84914 7.56711 10.4089 7.7 11 7.7C11.59 7.7 12.1488 7.56759 12.6484 7.33085C12.9 7.21157 13.1367 7.06582 13.3547 6.89717C13.3955 6.86557 13.4357 6.83318 13.4752 6.8ZM5.32238 5.26623C5.43668 5.00028 5.5 4.70742 5.5 4.4C5.5 4.21014 5.47585 4.02584 5.43046 3.85C5.37587 3.63855 5.29056 3.43934 5.1796 3.25742C4.79309 2.62376 4.09527 2.2 3.3 2.2C2.08656 2.2 1.1 3.18656 1.1 4.4C1.1 4.90764 1.27267 5.37558 1.56238 5.74818C1.73661 5.97228 1.95319 6.16189 2.2 6.30492C2.52375 6.49254 2.89952 6.6 3.3 6.6C3.70048 6.6 4.07625 6.49254 4.4 6.30492C4.64678 6.16191 4.86333 5.97233 5.03756 5.74827C5.15185 5.60129 5.24793 5.43947 5.32238 5.26623ZM1.11472 7.98663C0.449435 8.36534 0 9.08099 0 9.9V11C0 11.6084 0.491562 12.1 1.1 12.1H2.43616H3.36531C3.48468 11.2019 3.83693 10.3821 4.36105 9.7C4.37393 9.68324 4.38691 9.66656 4.4 9.64996C4.82054 9.11664 5.34733 8.67004 5.95031 8.33938C5.81197 8.20222 5.65583 8.08328 5.48563 7.98641C5.35057 7.90955 5.20667 7.84659 5.05577 7.79947C4.84873 7.73483 4.62853 7.7 4.4 7.7H3.47396H3.3H2.2C1.80557 7.7 1.43511 7.80424 1.11472 7.98663ZM7.91854 8.82436C7.39752 8.88221 6.90693 9.04123 6.46687 9.28133C5.37974 9.87447 4.60096 10.9624 4.43361 12.242C4.41144 12.4115 4.4 12.5844 4.4 12.76V13.75C4.4 13.8701 4.41284 13.9872 4.43723 14.1C4.59785 14.843 5.25915 15.4 6.05 15.4H15.95C16.7409 15.4 17.4022 14.843 17.5628 14.1C17.5872 13.9872 17.6 13.8701 17.6 13.75V12.76C17.6 12.5835 17.5884 12.4097 17.566 12.2393C17.398 10.9609 16.6195 9.87406 15.5331 9.28133C15.0931 9.04123 14.6025 8.88221 14.0815 8.82436C13.9365 8.80826 13.7892 8.8 13.64 8.8H13.3547C13.2414 8.85448 13.126 8.90551 13.0089 8.95282C12.3867 9.20395 11.7116 9.35 11 9.35C10.2882 9.35 9.61528 9.20385 8.99163 8.95255C8.87443 8.90532 8.75897 8.85438 8.64531 8.8H8.36C8.21078 8.8 8.06348 8.80826 7.91854 8.82436ZM8.23507 10.8039C7.21149 10.8685 6.4 11.7203 6.4 12.76V13.4H15.6V12.76C15.6 11.7206 14.789 10.869 13.7659 10.804C12.9247 11.1447 11.9937 11.35 11 11.35C10.004 11.35 9.07551 11.1438 8.23507 10.8039ZM17.6386 9.7C17.6259 9.68336 17.613 9.6668 17.6 9.65032C17.1797 9.11684 16.6528 8.67012 16.0497 8.33938C16.188 8.20222 16.3442 8.08328 16.5144 7.98641C16.6494 7.90955 16.7933 7.84659 16.9442 7.79947C17.1513 7.73483 17.3715 7.7 17.6 7.7H18.5259H18.7H19.8C20.1944 7.7 20.5649 7.80424 20.8853 7.98663C21.5506 8.36534 22 9.08099 22 9.9V11C22 11.6084 21.5084 12.1 20.9 12.1H19.5638H18.6313C18.5138 11.2019 18.1624 10.3821 17.6386 9.7ZM20.4376 5.74818C20.7273 5.37558 20.9 4.90764 20.9 4.4C20.9 3.18656 19.9134 2.2 18.7 2.2C17.9047 2.2 17.2069 2.62376 16.8204 3.25742C16.7094 3.43933 16.6241 3.63855 16.5695 3.85C16.5242 4.02584 16.5 4.21014 16.5 4.4C16.5 4.70742 16.5633 5.00028 16.6776 5.26623C16.7521 5.43947 16.8481 5.60129 16.9624 5.74827C17.1367 5.97233 17.3532 6.16191 17.6 6.30492C17.9237 6.49254 18.2995 6.6 18.7 6.6C19.1005 6.6 19.4763 6.49254 19.8 6.30492C20.0468 6.16189 20.2634 5.97228 20.4376 5.74818ZM11 5.7C12.0232 5.7 12.85 4.87324 12.85 3.85C12.85 2.82676 12.0232 2 11 2C9.97676 2 9.15 2.82676 9.15 3.85C9.15 4.87324 9.97676 5.7 11 5.7Z'
                fill='#173959'
              />
            </svg>
          ),
        },
        {
          title: 'We give back',
          smallTitle: 'How we help the community',
          link: '/we-give-back',
          props: {
            to: '/we-give-back',
          },
          icon: <img src='https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/heart+icon.png' />,
        },
        {
          title: 'Press room',
          smallTitle: 'Our news and media coverage',
          link: '/press-room',
          props: {
            to: '/press-room',
          },
          icon: (
            <svg width='22' height='18' viewBox='0 0 22 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <mask id='path-1-inside-1' fill='white'>
                <rect width='22' height='18' rx='1' />
              </mask>
              <rect width='22' height='18' rx='1' stroke='#173959' strokeWidth='4' mask='url(#path-1-inside-1)' />
              <rect x='4' y='4' width='14' height='5' rx='1' fill='#173959' />
              <rect x='4' y='11' width='6' height='1' rx='0.5' fill='#173959' />
              <rect x='12' y='11' width='6' height='1' rx='0.5' fill='#173959' />
              <rect x='4' y='13' width='6' height='1' rx='0.5' fill='#173959' />
              <rect x='12' y='13' width='6' height='1' rx='0.5' fill='#173959' />
            </svg>
          ),
        },
        {
          title: 'Contact us',
          smallTitle: 'Let us know how we can help',
          link: '/contact-us',
          props: {
            to: '/contact-us',
          },
          icon: (
            <svg
              shapeRendering='geometricPrecision'
              width='20'
              height='20'
              viewBox='0 0 20 20'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M6.875 8.43757H13.125C13.4703 8.43757 13.75 8.15788 13.75 7.81257V7.18758C13.75 6.84227 13.4703 6.56258 13.125 6.56258H6.875C6.52969 6.56258 6.25 6.84227 6.25 7.18758V7.81257C6.25 8.15788 6.52969 8.43757 6.875 8.43757ZM6.25 11.5625C6.25 11.9079 6.52969 12.1875 6.875 12.1875H13.125C13.4703 12.1875 13.75 11.9079 13.75 11.5625V10.9376C13.75 10.5922 13.4703 10.3126 13.125 10.3126H6.875C6.52969 10.3126 6.25 10.5922 6.25 10.9376V11.5625ZM10 16.2942C9.35859 16.2942 8.71719 16.0965 8.16953 15.7008L0 9.79928V18.125C0 19.1606 0.839453 20 1.875 20H18.125C19.1605 20 20 19.1606 20 18.125V9.79928L11.8305 15.7008C11.2828 16.0961 10.6414 16.2942 10 16.2942ZM19.2816 6.36532C18.9359 6.09422 18.6082 5.83915 18.125 5.47431V3.7501C18.125 2.71456 17.2855 1.87511 16.25 1.87511H13.2207C13.102 1.78917 12.9914 1.7087 12.8676 1.61886C12.2109 1.13957 10.9062 -0.0135513 10 0.000120522C9.09375 -0.0135513 7.78945 1.13957 7.13242 1.61886C7.00859 1.7087 6.89805 1.78917 6.7793 1.87511H3.75C2.71445 1.87511 1.875 2.71456 1.875 3.7501V5.47431C1.3918 5.83876 1.06406 6.09422 0.718359 6.36532C0.494593 6.54068 0.313639 6.76463 0.189185 7.02024C0.0647315 7.27584 3.8508e-05 7.5564 0 7.8407L0 8.25671L3.75 10.9657V3.7501H16.25V10.9657L20 8.25671V7.8407C20 7.26492 19.7352 6.72078 19.2816 6.36532Z'
                fill='#173959'
              />
            </svg>
          ),
        },
      ],
    },
  ];

  let mobileMenuItems;
  if (context.auth.isLoggedIn()) {
    const headerProfileType = context.auth.getCurrentUser().current_profile_type;
    if (headerProfileType === 'AccountAdmin') {
      mobileMenuItems = [
        {
          mainLink: {
            onclick: 'logout',
            title: 'Log out',
          },
        },
      ];
    } else {
      mobileMenuItems = [
        {
          mainLink: {
            title: 'Conversations',
            link: '/member/conversations',
          },
        },
        {
          mainLink: {
            onclick: 'logout',
            title: 'Log out',
          },
        },
      ];
    }
  } else {
    mobileMenuItems = [
      {
        mainLink: {
          title: 'Join for free',
          link: '/member/join/pre-signup',
        },
      },
    ];
  }

  const navItemsAnimation = useSpringRef();
  const mobileNavItems = useTransition(navOpen ? [...menuItems, ...mobileMenuItems] : [], {
    ref: navItemsAnimation,
    trail: navOpen ? 100 / menuItems.length : 0,
    config: { mass: 0.5, tension: 200, friction: 20 },
    from: { opacity: 0, transform: 'translateX(50px)' },
    enter: { opacity: 1, transform: 'translateX(0px)' },
  });

  useChain(navOpen ? [navItemsAnimation] : [navItemsAnimation], [0.2]);

  return (
    <header id='hdr-content'>
      <div className='container-fluid'>
        <div className='header-outr row'>
          <div className={`${isMobile ? 'col-4' : 'col-2'}`}>
            <div className='hdr-logo'>
              <Link to='/'>
                <img
                  alt='logo'
                  id='logo'
                  src='https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/logos/svg/pp-logo.svg'
                />
              </Link>
            </div>
          </div>
          <div className={`text-center ${isMobile ? '' : 'col-7'}`}>
            <div className='header-innr'>
              <div className='navbar-header'>
                <nav
                  className='navbar navbar-expand-md navbar-light sidenav'
                  id='mySidenav'
                  style={{ right: navOpen ? '0px' : '-100%' }}
                >
                  {isMobile === true && (
                    <Link onClick={() => setNavOpen(false)} to='/'>
                      <img
                        alt='logo'
                        className={`mobile-nav-logo ${navOpen ? 'active' : ''}`}
                        src='https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/logos/svg/pp-logo.svg'
                      />
                    </Link>
                  )}
                  <div>
                    <ul className='navbar-nav'>
                      {isMobile === false && (
                        <>
                          {menuItems.map((menuItem, index) => (
                            <DesktopNavItem key={index} navItem={menuItem} />
                          ))}
                        </>
                      )}
                      {isMobile === true && (
                        <>
                          {mobileNavItems((style, menuItem) => (
                            <animated.div
                              key={menuItem.mainLink.title}
                              style={{ ...style }}
                              className='mobile-nav-item-animated-wrap'
                            >
                              <MobileNavItem navItem={menuItem} setNavOpen={setNavOpen} />
                            </animated.div>
                          ))}
                        </>
                      )}
                    </ul>
                  </div>
                </nav>
              </div>
            </div>
          </div>
          <div className={`hdr-btn-wrap ${isMobile ? (isSmallMobile ? 'col-6' : 'col-7') : 'col-3'}`}>
            <div style={{ width: '100%', display: 'flex', alignItems: 'center' }} className='hdr-btn-innr'>
              {!isMobile && (
                <Link to='/member/login'>
                  <GhostButton className={styles.login_btn} style={{ marginBottom: '0px' }}>
                    Login
                  </GhostButton>
                </Link>
              )}
              {showLogin ? (
                <Link className={styles.join_btn} to='/member/login'>
                  <button style={{ padding: '12px 20px' }}>Login</button>
                </Link>
              ) : (
                <Link className={styles.join_btn} to='/member/join/support'>
                  <button style={{ padding: '12px 20px' }}>Get Started</button>
                </Link>
              )}
            </div>
          </div>
          <div
            style={isSmallMobile ? {} : { width: 'max-content', maxWidth: 'max-content' }}
            className={`${isMobile ? 'col-1' : ''} col-1`}
          >
            <svg
              onClick={() => {
                setNavOpen(!navOpen);
              }}
              id='ham_icn'
              className={`tgl-innr ham hamRotate ham1 ${navOpen ? 'active' : ''}`}
              viewBox='0 0 100 100'
              width='60'
            >
              <path
                className='line top'
                d='m 30,33 h 40 c 0,0 9.044436,-0.654587 9.044436,-8.508902 0,-7.854315 -8.024349,-11.958003 -14.89975,-10.85914 -6.875401,1.098863 -13.637059,4.171617 -13.637059,16.368042 v 40'
              />
              <path className='line middle' d='m 30,50 h 40' />
              <path
                className='line bottom'
                d='m 30,67 h 40 c 12.796276,0 15.357889,-11.717785 15.357889,-26.851538 0,-15.133752 -4.786586,-27.274118 -16.667516,-27.274118 -11.88093,0 -18.499247,6.994427 -18.435284,17.125656 l 0.252538,40'
              />
            </svg>
          </div>
        </div>
      </div>
    </header>
  );
}
